<smart-table [headers]="headers"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [source]="source">
  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.name }} <br>
      <small class="text-muted">ID {{ item.id }}</small>
    </td>
  </ng-template>

  <ng-template smartTableColumn="vendorID" let-item>
    <td>
      {{ item.vendorID }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="idfa" let-item>
    <td>
      {{ item.idfa }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="androidId" let-item>
    <td>
      {{ item.androidId }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="usedAt" let-item>
    <td>
      {{ item.lastUsedAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="actions" let-item>
    <td class="text-right text-nowrap">
      <button class="btn btn-danger btn-square btn-icon">
        <icon-trash></icon-trash>
      </button>
    </td>
  </ng-template>
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>


